var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"items":_vm.options,"value":_vm.value,"item-text":"text","item-value":"id","outlined":_vm.hasOutline,"dense":_vm.hasDense},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_vm._t("prepend-inner")]},proxy:true}],null,true)},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }